import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "posAb pointer z1",
  style: {"top":"5px","right":"2px"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "fs14 fw600 arial ml4 mt8",
  style: {}
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "label with_white_bg orange fw600" }, "強制枠", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "fs12"
}
const _hoisted_10 = {
  key: 2,
  class: "fs12"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "fs13" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventMenu = _resolveComponent("EventMenu")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Vue3DraggableResizable = _resolveComponent("Vue3DraggableResizable")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.clickEv(_ctx.ev)), ["self"])),
    class: _normalizeClass(`w90`)
  }, [
    (_ctx.currentEvent && _ctx.editEvDic && _ctx.editEvDic.duration != 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle(`top:${_ctx.editEvDic.start_cell * _ctx.CELL_HEIGHT + _ctx.alldayHeight - 22}px;left:1%;background: rgba(0,0,0,0.6);`),
          class: _normalizeClass(`posAb rad5 displayDuration fs11 fw600 pad5 whiteColor z5`)
        }, _toDisplayString(_ctx.editEvDic.duration * 15) + "分 ", 5))
      : _createCommentVNode("", true),
    ([`optional_add`, `optional_remove`].includes(_ctx.ev.type))
      ? (_openBlock(), _createBlock(_component_Vue3DraggableResizable, {
          key: 1,
          active: true,
          draggable: false,
          resizable: _ctx.cm.isOpeningEventMenu && _ctx.isSelectingSameDate ? false : true,
          initW: _ctx.ev.is_force ? 80 : 90,
          initH: (_ctx.ev.duration / 15) * _ctx.CELL_HEIGHT - 3,
          y: (_ctx.ev.start_hour * 4 + _ctx.ev.start_min / 15) * _ctx.CELL_HEIGHT + _ctx.alldayHeight,
          x: 5,
          class: _normalizeClass(`${_ctx.addtionalClass} posAb rad5 opEvent ${_ctx.isSelectingEvent ? `z5 borderWhite l2 with_shadow` : ``} clickable${
                _ctx.ev.short_format
            }`),
          handles: ['tm', 'bm'],
          onResizing: _ctx.move,
          onResizeStart: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startDrag(_ctx.ev))),
          onResizeEnd: _ctx.endDrag,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickEv(_ctx.ev)))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("img", {
                src: 
                        _ctx.$getAssetImageUrl(
                            _ctx.ev.type == `optional_add` ? `/assets/popUp/close_dark_grey.png` : `/assets/popUp/close_white.png`
                        )
                    ,
                width: "20",
                height: "20",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteOptionalEvent(_ctx.ev)))
              }, null, 8, _hoisted_2)
            ]),
            _createVNode(_component_Dropdown, { ref: "dropdown" }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_EventMenu, {
                  ev: _ctx.ev,
                  onAddEvent: _ctx.addEvent
                }, null, 8, ["ev", "onAddEvent"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(`dropdown-toggle whiteColor w90 rad5 availableBox pointer`),
                  style: ``,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickEv(_ctx.ev)))
                }, [
                  _createElementVNode("p", _hoisted_3, [
                    (!_ctx.isSP)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                          (_ctx.ev.is_force)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
                            : _createCommentVNode("", true),
                          (_ctx.ev.type == `optional_add`)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "調整可能"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_10, "不可")),
                          _hoisted_11,
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.DateTime.fromSeconds(_ctx.ev.start_time).toFormat("HH:mm")) + " ~ " + _toDisplayString(_ctx.DateTime.fromSeconds(_ctx.ev.start_time).plus({ minutes: _ctx.ev.duration }).toFormat("HH:mm")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }, 8, ["resizable", "initW", "initH", "y", "class", "onResizing", "onResizeEnd"]))
      : _createCommentVNode("", true)
  ]))
}